import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {NgStrapiAuthConfig} from '../../../services/strapi/auth/ng-strapi-auth-config';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  public code: string;
  private apiUrl: string;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient,
              @Inject('config') private config: NgStrapiAuthConfig) {
    if (this.config && this.config.apiUrl) {
      this.apiUrl = this.config.apiUrl;
    } else {
      const err = '[NgStrapiAuth]: no api url provided';
      console.error(err);
      throw new Error('[NgStrapiAuth]: no api url provided');
    }
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParamMap.get('code');
    if (this.code === null) {
      this.router.navigate(['login']);
    }
    // make a post request to the backend with the code to get data

  }

}
